/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { styles } from './column.styles';

export enum ColumnVariant {
    FLUID = 'fluid',
    SIDEBAR = 'sidebar',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface ColumnProps {
    /**
     * The variant of the column
     */
    variant: ColumnVariant;

    /**
     * Child elements
     */
    children?: ReactNode;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;

    /**
     * The flex fraction (fr) assigned to the column. This is used for styling
     */
    flexFraction?: number;
}

const StyledColumn = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const Column: FunctionComponent<ColumnProps> = ({
    children,
    ...otherProps
}: ColumnProps) => {
    return <StyledColumn {...otherProps}>{children}</StyledColumn>;
};
